import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CelebrationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M7.72008 11.27C7.31008 10.86 6.73008 10.68 6.16008 10.79C5.59008 10.9 5.12008 11.27 4.88008 11.8L0.890084 20.8C0.590084 21.47 0.740084 22.23 1.25008 22.75C1.77008 23.27 2.54008 23.4 3.20008 23.11L12.2001 19.11C12.7301 18.88 13.1001 18.4 13.2101 17.83C13.3201 17.26 13.1301 16.68 12.7301 16.27L7.73008 11.27H7.72008ZM2.59008 21.74C2.36008 21.82 2.18008 21.64 2.26008 21.41L4.80008 15.69L8.31008 19.2L2.59008 21.74ZM11.5901 17.74L9.53008 18.65L5.34008 14.46L6.25008 12.4C6.35008 12.22 6.51008 12.21 6.65008 12.33L11.6501 17.33C11.7701 17.5 11.7501 17.62 11.5801 17.73L11.5901 17.74Z"
        fill={color}
      />
      <path
        d="M20.3001 15.1898C20.5401 15.4298 20.9401 15.4298 21.1801 15.1898C21.4201 14.9498 21.4201 14.5498 21.1801 14.3098C19.2801 12.4098 16.1901 12.4098 14.3001 14.3098C14.0601 14.5498 14.0601 14.9498 14.3001 15.1898C14.5401 15.4298 14.9401 15.4298 15.1801 15.1898C16.5901 13.7798 18.8901 13.7798 20.3001 15.1898Z"
        fill={color}
      />
      <path
        d="M8.60993 9.49018C8.84993 9.73018 9.24993 9.73018 9.48993 9.49018C11.9399 7.04018 11.9399 3.06018 9.48993 0.610176C9.24993 0.370176 8.84993 0.370176 8.60993 0.610176C8.36993 0.850176 8.36993 1.25018 8.60993 1.49018C10.5699 3.45018 10.5699 6.64017 8.60993 8.61018C8.36993 8.85017 8.36993 9.25018 8.60993 9.49018Z"
        fill={color}
      />
      <path
        d="M5.63 4H4.62C4.27758 4 4 4.27758 4 4.62V5.63C4 5.97242 4.27758 6.25 4.62 6.25H5.63C5.97242 6.25 6.25 5.97242 6.25 5.63V4.62C6.25 4.27758 5.97242 4 5.63 4Z"
        fill={color}
      />
      <path
        d="M18.38 20.75H17.37C17.0276 20.75 16.75 21.0276 16.75 21.37V22.38C16.75 22.7224 17.0276 23 17.37 23H18.38C18.7224 23 19 22.7224 19 22.38V21.37C19 21.0276 18.7224 20.75 18.38 20.75Z"
        fill={color}
      />
      <path
        d="M13.63 9H12.62C12.2776 9 12 9.27758 12 9.62V10.63C12 10.9724 12.2776 11.25 12.62 11.25H13.63C13.9724 11.25 14.25 10.9724 14.25 10.63V9.62C14.25 9.27758 13.9724 9 13.63 9Z"
        fill={color}
      />
      <path
        d="M21.38 17H20.37C20.0276 17 19.75 17.2776 19.75 17.62V18.63C19.75 18.9724 20.0276 19.25 20.37 19.25H21.38C21.7224 19.25 22 18.9724 22 18.63V17.62C22 17.2776 21.7224 17 21.38 17Z"
        fill={color}
      />
      <path
        d="M19.63 8H18.62C18.2776 8 18 8.27758 18 8.62V9.63C18 9.97242 18.2776 10.25 18.62 10.25H19.63C19.9724 10.25 20.25 9.97242 20.25 9.63V8.62C20.25 8.27758 19.9724 8 19.63 8Z"
        fill={color}
      />
      <path
        d="M17.63 1.75H16.62C16.2776 1.75 16 2.02758 16 2.37V3.38C16 3.72242 16.2776 4 16.62 4H17.63C17.9724 4 18.25 3.72242 18.25 3.38V2.37C18.25 2.02758 17.9724 1.75 17.63 1.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CelebrationIcon.displayName = 'CelebrationIcon';
